import { render, staticRenderFns } from "./ActTypeForm.vue?vue&type=template&id=aff34a00&scoped=true"
import script from "./ActTypeForm.vue?vue&type=script&lang=js"
export * from "./ActTypeForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=aff34a00&prod&scoped=true&lang=css&external"
import style1 from "./ActTypeForm.vue?vue&type=style&index=1&id=aff34a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff34a00",
  null
  
)

export default component.exports